import { css } from '@emotion/react';
import {
  type FC, type PropsWithChildren,
  type ReactElement,
} from 'react';
import { ButtonComponent } from '~/_shared/baseComponents/buttons/button/button.component';
import { ButtonStyle } from '~/_shared/baseComponents/buttons/button/button.types';
import { useTranslation } from '~/_shared/utils/hooks';

export const LAYERED_MAP_MAP_INFO_CONTAINER_MAX_WIDTH = 500;

const containerStyle = ({ maxWidth }: { maxWidth: number | string }) => css({
  maxWidth,
});

const buttonPositionStyle = css({
  alignItems: 'center',
  display: 'flex',
  gap: 10,
  justifyContent: 'end',
  marginTop: 8,
});

const additionalButtonsContainerStyle = css({
  display: 'flex',
  gap: 10,
});

type ButtonProps = {
  isDisabled: boolean;
  text?: string;

  onClick: () => void;
};

type LayeredMapStepContentHolderComponentProps = PropsWithChildren<Readonly<{
  buttonProps: ButtonProps;
  maxContentWidth?: number | string;
  secondaryButtonProps?: ButtonProps;
  additionalButtons?: ReadonlyArray<ReactElement>;
}>>;

export const LayeredMapSectionHolderComponent: FC<LayeredMapStepContentHolderComponentProps> = (props) => {
  const [t] = useTranslation();

  const maxContentWidth = props.maxContentWidth ?? LAYERED_MAP_MAP_INFO_CONTAINER_MAX_WIDTH;

  return (
    <div>
      <div css={containerStyle({ maxWidth: maxContentWidth })}>
        {props.children}
      </div>

      <div css={buttonPositionStyle}>
        {props.additionalButtons && (
          <div css={additionalButtonsContainerStyle}>
            {props.additionalButtons.map((button, index) => (
              <div key={index}>
                {button}
              </div>
            ))}
          </div>
        )}
        {props.secondaryButtonProps && (
          <ButtonComponent
            buttonStyle={ButtonStyle.Quaternary}
            text={props.secondaryButtonProps.text}
            onClick={props.secondaryButtonProps.onClick}
          />
        )}
        <ButtonComponent
          buttonStyle={ButtonStyle.Primary}
          isDisabled={props.buttonProps.isDisabled}
          onClick={props.buttonProps.onClick}
          text={props.buttonProps.text || t('Continue')}
        />
      </div>
    </div>
  );
};
